<!-- 海底奇遇 -->
<style scoped>
    .bg-mermaid{
        background: url('@/assets/images/room/maze/ts.png') no-repeat center top/100% auto;
    }
    .bg-shak-red{
        background: url('@/assets/images/room/maze/hs.png') no-repeat left center/auto 100%;
    }
    .bg-mobula{
        background: url('@/assets/images/room/maze/lf.png') no-repeat left center/auto 100%;
    }
    .bg-shak-red-mobula{
        background: url('@/assets/images/room/maze/hs.png') no-repeat left center/auto 70%,
                    url('@/assets/images/room/maze/lf.png') no-repeat 35% center/auto 70%;
    }
    .bg-shak-blue{
        background: url('@/assets/images/room/maze/ls.png') no-repeat right center/auto 100%;
    }
    .bg-turtle{
        background: url('@/assets/images/room/maze/hg.png') no-repeat right center/auto 100%;
    }
    .bg-shak-blue-turtle{
        background: url('@/assets/images/room/maze/ls.png') no-repeat right center/auto 70%,
                    url('@/assets/images/room/maze/hg.png') no-repeat 70% center/auto 70%;
    }
    .coruscate{
        animation: coruscate .5s ease infinite alternate;
    }
	@keyframes coruscate {
        0% {
            background: rgba(25,135,84,1);
        }
        100% {
            background: rgba(13,202,240);
        }
    }
    @media (min-width: 576px) {
        .bg-mermaid{
            background: url('@/assets/images/room/maze/ts.png') no-repeat left center/65% 100%;
        }
        .bg-shak-red{
            background: url('@/assets/images/room/maze/hs.png') no-repeat 70% center/auto 100%;
        }
        .bg-mobula{
            background: url('@/assets/images/room/maze/lf.png') no-repeat 90% center/auto 100%;
        }
        .bg-shak-blue{
            background: url('@/assets/images/room/maze/ls.png') no-repeat 70% center/auto 100%;
        }
        .bg-turtle{
            background: url('@/assets/images/room/maze/hg.png') no-repeat right bottom/70% 90%;
        }
        .bg-shak-red-mobula{
            background: url('@/assets/images/room/maze/hs.png') no-repeat 90% top/auto 70%,
                        url('@/assets/images/room/maze/lf.png') no-repeat 10% bottom/auto 70%;
        }
        .bg-shak-blue-turtle{
            background: url('@/assets/images/room/maze/ls.png') no-repeat 90% top/auto 70%,
                        url('@/assets/images/room/maze/hg.png') no-repeat 20% 120%/auto 60%;
        }
    }
</style>
<template>
    <div class="d-flex flex-column h-100">
        <!-- 横向导航 -->
        <navbar class="order-first d-flex flex-column d-sm-none" :has-chat-msg="hasChatMsg" :is-fullscreen="isFullscreen"></navbar>
        <!-- 主内容 -->
        <div class="d-flex flex-grow-1 h-0 flex-column position-xs-relative start-0 end-0 top-0">
            <!-- 经典 -->
            <div class="d-flex flex-column flex-sm-row position-relative flex-grow-0 flex-sm-grow-1 h-sm-0">
                <!-- 纵向导航 -->
                <navbar-vertical class="d-none d-sm-flex" :is-fullscreen="isFullscreen"></navbar-vertical>
                <!-- 视频区 -->
                <div class="d-flex flex-column flex-grow-1 position-relative">
                    <!-- 公告 -->
                    <notice class="d-none d-sm-flex position-absolute index-12"></notice>
                    <!-- 视频 -->
                    <div class="d-flex h-0 pt-60 position-relative overflow-hidden flex-grow-1 pt-sm-0">
                        <media-video id="video1" class="position-xs-absolute position-sm-relative top-0 start-0" :class="{'bg-transparent img-sm-thumbnail':roomInfo.isar!=1}" :video-index="0" :video-list="videoList" :countdown="roomInfo.countdown" :room-class="['top-sm-0 mt-2 mt-sm-5 ms-1 ms-sm-2 index-12']" :time-class="['top-0 mt-2 mt-sm-5 ms-2']" :img-class="['position-absolute translate-middle top-50 start-50 w-100 h-sm-100']"></media-video>
                    </div>
                    <!-- 提交区 -->
                    <div class="position-xs-relative start-0 end-0 bottom-0 top-0 d-flex flex-column flex-sm-row" :class="{'position-sm-absolute':roomInfo.isar==1}">
                        <!-- 额度统计 -->
                        <div class="d-flex text-light justify-content-around lh-1 py-1">
                            <div class="flex-grow-1 d-flex flex-sm-column justify-content-around" :class="{'fs-sm-5 justify-content-sm-start align-items-center':roomInfo.isar==1}">
                                <span class="d-flex flex-sm-column align-items-center align-items-sm-start">
                                    <span>{{$t("room.ingBet")}}：</span>
                                    <span>{{getAmountCount("submiting")}}</span>
                                </span>
                                <span class="d-flex flex-sm-column align-items-center align-items-sm-start" :class="{'ms-sm-2 ms-md-3 ms-lg-4':roomInfo.isar==1}">
                                    <span>{{$t("room.edBet")}}：</span>
                                    <span>{{getAmountCount("submited")}}</span>
                                </span>
                                <span class="d-flex flex-sm-column align-items-center align-items-sm-start" :class="{'ms-sm-2 ms-md-3 ms-lg-4':roomInfo.isar==1}">
                                    <span>{{$t("room.allBet")}}：</span>
                                    <span>{{getAmountCount("submited")+getAmountCount("submiting")}}</span>
                                </span>
                            </div>
                        </div>
                        <!-- 操作区 -->
                        <div v-if="gameModel==GAME_MODEL.normal" class="position-xs-relative bottom-0 index-12 perspective-600 flex-grow-1" :class="{'translate-middle-x start-50 position-sm-absolute':roomInfo.isar==1,'position-sm-relative':roomInfo.isar!=1}">
                            <div class="pb-1 pt-sm-1 pb-sm-0 transform-3d mb-sm-2" :class="{'rotate3d-x-sm-50':roomInfo.isar==1,'me-sm-2':roomInfo.isar!=1}">
                                <div class="d-flex flex-column transform-3d flex-sm-row">
                                    <div class="d-flex flex-column flex-grow-1 transform-3d">
                                        <div class="d-flex flex-grow-1 flex-column-reverse transform-3d" :class="{'flex-sm-row':roomInfo.isar==1,'flex-row flex-sm-row-reverse':roomInfo.isar!=1}">
                                            <div :class="{'flex-sm-row ps-sm-1 pe-sm-2':roomInfo.isar!=1,'flex-sm-column-reverse':roomInfo.isar==1}" class="d-flex flex-column px-1 px-sm-0">
                                                <!-- 选筹区 -->
                                                <div class="d-flex justify-content-between justify-content-sm-around text-black order-2 order-sm-1 mb-2 mb-sm-0 flex-grow-1 flex-sm-column" :class="{'col':roomInfo.isar!=1}">
                                                    
                                                    <div v-for="(item,i) in currAmountList" :key="i" class="d-flex justify-content-around align-items-center col" :class="{'col-sm-auto justify-content-sm-start':roomInfo.isar==1}">
                                                        <div v-for="j in 2" :key="j" class="position-relative me-1 chips rounded-circle" :class="{active:amount==item[j-1]}" @click="amount=item[j-1]" role="button">
                                                            <button v-if="i==2&&j==2" @click.stop="isShowMoreAmount=!isShowMoreAmount" class="btn btn-secondary btn-shadow-left text-light">
                                                                <i class="bi bi-grid-fill"></i>
                                                            </button>
                                                            <chip v-else :foot-class="['bg-'+item[j-1],(roomInfo.isar==1)?'ms-sm-_1rem':'']" :face-class="['bg-'+item[j-1]]" :chip-text="$root.chipsTxtConvert(item[j-1])"></chip>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                            <!-- 下单区 -->
                                            <div class="flex-grow-1 d-flex align-items-sm-stretch position-relative order-1 order-sm-2 text-center mb-2 mb-sm-0 transform-3d p-1 text-light h-15rem h-sm-100">
                                                <!-- 左 -->
                                                <div class="d-flex flex-column flex-sm-row col">
                                                    <!-- hs -->
                                                    <div class="col position-relative" :class="{'coruscate':coruscateArr.indexOf('hs')!=-1}" @click="addAmount('hs',$event)">
                                                        <div class="d-flex flex-column justify-content-evenly justify-content-sm-start align-items-end align-items-sm-start bg-shak-red w-100 h-100 pe-4 pe-sm-0 ps-sm-3">
                                                            <!-- 文本 -->
                                                            <span class="text-danger text-shadow-white fw-bold fs-5">红鲨</span>
                                                            <span>1 : <span class="fw-bold" :style="{transform: 'scale('+(1+(odds['select1']-1)*0.06)+')'}">{{ odds["select1"] }}</span></span>
                                                            <span class="text-light text-opacity-50">{{limitred['select1'].join('-')}}</span>
                                                            <img class="position-absolute top-100 w-100 h-1rem start-0 index-_1 d-sm-none" style="transform: rotateZ(180deg) translateY(80%) rotateZ(8deg);" src="@/assets/images/room/maze/seaweed1.png" alt="">
                                                            <!-- 单额 -->
                                                            <div class="position-absolute start-50 me-5 me-sm-4 top-55 w-0 h-0 transform-3d">
                                                                <div :class="{'chip-pulse opacity-75':submiting.hs>0}" class="position-absolute">
                                                                    <div v-for="j,index in chipsConvert(submited.hs+submiting.hs)" :key="j" :style="'bottom:'+(0.2*index)+'rem !important'" class="position-absolute fs-6 text-black translate-middle-x" :class="{'chips-img-shadow':index==0}">
                                                                        <chip :foot-class="['bg-'+j]" :face-class="['bg-'+j]" :chip-text="$root.chipsTxtConvert(j)"></chip>
                                                                        <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                                    </div>
                                                                </div>
                                                                <div v-if="submited.hs+submiting.hs>0" :class="[roomInfo.isar==1?'anim-updown-3d':'anim-updown']" class="position-absolute text-black fw-bold fs-6 bottom-0 p-2 rounded-circle bubble" style="transform:translateX(-50%) translateZ(3rem) rotateX(-50deg) translateZ(-2.5rem);">
                                                                    <span class="d-block scale pt-100 h-0">
                                                                        <span class="visibility-hidden" :class="{'fs-scale-1_2rem':isScaleAmount.hs}">{{submited.hs+submiting.hs>0?submited.hs+submiting.hs:''}}</span>
                                                                        <small :class="{'text-danger':submited.hs+submiting.hs<limitred.select1[0]}" class="text-shadow-white position-absolute top-50 start-50 translate-middle">{{submited.hs+submiting.hs>0?submited.hs+submiting.hs:''}}</small>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- 池额 -->
                                                            <div @click.stop :class="{'rotate-sm-x-_50-z-4px':pool.hs>0&&roomInfo.isar==1}" class="position-absolute bottom-0 start-0 transform-bottom index-1">
                                                                <div @mousemove="isShowPoolText=true" @mouseout="isShowPoolText=false" class="progress-ring fs-_8rem d-flex justify-content-center align-items-center position-relative rounded-pill overflow-hidden" :style="{background: 'conic-gradient(#00e5ff calc('+((pool.hs/(Number(pool.hs)+Number(pool.lf)+Number(pool.hslf)+Number(pool.ls)+Number(pool.hg)+Number(pool.hgls)+Number(pool.ts))*100||0).toFixed()+'%')+'), #787878 0)'}">
                                                                    <div :class="{'progress-text-show':isShowPoolText}" class="progress-text text-light h-1_5rem d-flex justify-content-center align-items-center m-_15rem">
                                                                        <span>{{(pool.hs/(Number(pool.hs)+Number(pool.lf)+Number(pool.hslf)+Number(pool.ls)+Number(pool.hg)+Number(pool.hgls)+Number(pool.ts))*100||0).toFixed()}}<span class="fs-_5rem">%</span></span>
                                                                        <span class="px-2">{{ pool.hs }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- hslf -->
                                                    <div class="col position-relative" :class="{'coruscate':coruscateArr.indexOf('hslf')!=-1}" @click="addAmount('hslf',$event)">
                                                        <div class="d-flex flex-column justify-content-evenly justify-content-sm-start align-items-end align-items-sm-start bg-shak-red-mobula w-100 h-100 pe-4 pe-sm-0 ps-sm-3">
                                                            <!-- 文本 -->
                                                            <div class="d-none d-sm-block">
                                                                <span class="text-danger text-shadow-white fw-bold">红鲨</span>
                                                                <span> / </span>
                                                                <span class="text-primary text-shadow-white fw-bold">蓝蝠</span>
                                                            </div>
                                                            <span>1 : <span class="fw-bold" :style="{transform: 'scale('+(1+(odds['select2']-1)*0.06)+')'}">{{odds["select2"]}}</span></span>
                                                            <span class="text-light text-opacity-50">{{limitred['select2'].join('-')}}</span>
                                                            <img class="position-absolute top-100 w-100 h-1rem start-0 index-_1 d-sm-none" style="transform: rotateZ(180deg) translateY(90%) rotateZ(8deg);" src="@/assets/images/room/maze/seaweed1.png" alt="">
                                                            <img class="position-absolute h-100 w-2rem end-100 translate-50-x d-none d-sm-block" src="@/assets/images/room/maze/seaweed.png" alt="">
                                                            <img class="position-absolute h-100 w-2rem start-100 translate--50-x d-none d-sm-block" src="@/assets/images/room/maze/seaweed.png" alt="">
                                                            <!-- 单额 -->
                                                            <div class="position-absolute start-50 me-5 me-sm-4 top-55 w-0 h-0 transform-3d">
                                                                <div :class="{'chip-pulse opacity-75':submiting.hslf>0}" class="position-absolute">
                                                                    <div v-for="j,index in chipsConvert(submited.hslf+submiting.hslf)" :key="j" :style="'bottom:'+(0.2*index)+'rem !important'" class="position-absolute fs-6 text-black translate-middle-x" :class="{'chips-img-shadow':index==0}">
                                                                        <chip :foot-class="['bg-'+j]" :face-class="['bg-'+j]" :chip-text="$root.chipsTxtConvert(j)"></chip>
                                                                        <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                                    </div>
                                                                </div>
                                                                <div v-if="submited.hslf+submiting.hslf>0" :class="[roomInfo.isar==1?'anim-updown-3d':'anim-updown']" class="position-absolute text-black fw-bold fs-6 bottom-0 p-2 rounded-circle bubble" style="transform:translateX(-50%) translateZ(3rem) rotateX(-50deg) translateZ(-2.5rem);">
                                                                    <span class="d-block scale pt-100 h-0">
                                                                        <span class="visibility-hidden" :class="{'fs-scale-1_2rem':isScaleAmount.hslf}">{{submited.hslf+submiting.hslf>0?submited.hslf+submiting.hslf:''}}</span>
                                                                        <small :class="{'text-danger':submited.hslf+submiting.hslf<limitred.select2[0]}" class="text-shadow-white position-absolute top-50 start-50 translate-middle">{{submited.hslf+submiting.hslf>0?submited.hslf+submiting.hslf:''}}</small>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- 池额 -->
                                                            <div @click.stop :class="{'rotate-sm-x-_50-z-4px':pool.hslf>0&&roomInfo.isar==1}" class="position-absolute bottom-0 start-0 transform-bottom index-1">
                                                                <div @mousemove="isShowPoolText=true" @mouseout="isShowPoolText=false" class="progress-ring fs-_8rem d-flex justify-content-center align-items-center position-relative rounded-pill overflow-hidden" :style="{background: 'conic-gradient(#00e5ff calc('+((pool.hslf/(Number(pool.hslf)+Number(pool.lf)+Number(pool.hs)+Number(pool.ls)+Number(pool.hg)+Number(pool.hgls)+Number(pool.ts))*100||0).toFixed()+'%')+'), #787878 0)'}">
                                                                    <div :class="{'progress-text-show':isShowPoolText}" class="progress-text text-light h-1_5rem d-flex justify-content-center align-items-center m-_15rem">
                                                                        <span>{{(pool.hslf/(Number(pool.hslf)+Number(pool.lf)+Number(pool.hs)+Number(pool.ls)+Number(pool.hg)+Number(pool.hgls)+Number(pool.ts))*100||0).toFixed()}}<span class="fs-_5rem">%</span></span>
                                                                        <span class="px-2">{{ pool.hslf }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- lf -->
                                                    <div class="col position-relative" :class="{'coruscate':coruscateArr.indexOf('lf')!=-1}" @click="addAmount('lf',$event)">
                                                        <div class="d-flex flex-column justify-content-evenly justify-content-sm-start align-items-end align-items-sm-start bg-mobula w-100 h-100 pe-4 pe-sm-0 ps-sm-3">
                                                            <!-- 文本 -->
                                                            <span class="text-primary text-shadow-white fw-bold fs-5">蓝蝠</span>
                                                            <span>1 : <span class="fw-bold" :style="{transform: 'scale('+(1+(odds['select1']-1)*0.06)+')'}">{{odds["select1"]}}</span></span>
                                                            <span class="text-light text-opacity-50">{{limitred['select1'].join('-')}}</span>
                                                            <!-- 单额 -->
                                                            <div class="position-absolute start-50 me-5 me-sm-4 top-55 w-0 h-0 transform-3d">
                                                                <div :class="{'chip-pulse opacity-75':submiting.lf>0}" class="position-absolute">
                                                                    <div v-for="j,index in chipsConvert(submited.lf+submiting.lf)" :key="j" :style="'bottom:'+(0.2*index)+'rem !important'" class="position-absolute fs-6 text-black translate-middle-x" :class="{'chips-img-shadow':index==0}">
                                                                        <chip :foot-class="['bg-'+j]" :face-class="['bg-'+j]" :chip-text="$root.chipsTxtConvert(j)"></chip>
                                                                        <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                                    </div>
                                                                </div>
                                                                <div v-if="submited.lf+submiting.lf>0" :class="[roomInfo.isar==1?'anim-updown-3d':'anim-updown']" class="position-absolute text-black fw-bold fs-6 bottom-0 p-2 rounded-circle bubble" style="transform:translateX(-50%) translateZ(3rem) rotateX(-50deg) translateZ(-2.5rem);">
                                                                    <span class="d-block scale pt-100 h-0">
                                                                        <span class="visibility-hidden" :class="{'fs-scale-1_2rem':isScaleAmount.lf}">{{submited.lf+submiting.lf>0?submited.lf+submiting.lf:''}}</span>
                                                                        <small :class="{'text-danger':submited.lf+submiting.lf<limitred.select1[0]}" class="text-shadow-white position-absolute top-50 start-50 translate-middle">{{submited.lf+submiting.lf>0?submited.lf+submiting.lf:''}}</small>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- 池额 -->
                                                            <div @click.stop :class="{'rotate-sm-x-_50-z-4px':pool.lf>0&&roomInfo.isar==1}" class="position-absolute bottom-0 start-0 transform-bottom index-1">
                                                                <div @mousemove="isShowPoolText=true" @mouseout="isShowPoolText=false" class="progress-ring fs-_8rem d-flex justify-content-center align-items-center position-relative rounded-pill overflow-hidden" :style="{background: 'conic-gradient(#00e5ff calc('+((pool.lf/(Number(pool.hs)+Number(pool.lf)+Number(pool.hslf)+Number(pool.ls)+Number(pool.hg)+Number(pool.hgls)+Number(pool.ts))*100||0).toFixed()+'%')+'), #787878 0)'}">
                                                                    <div :class="{'progress-text-show':isShowPoolText}" class="progress-text text-light h-1_5rem d-flex justify-content-center align-items-center m-_15rem">
                                                                        <span>{{(pool.lf/(Number(pool.hs)+Number(pool.lf)+Number(pool.hslf)+Number(pool.ls)+Number(pool.hg)+Number(pool.hgls)+Number(pool.ts))*100||0).toFixed()}}<span class="fs-_5rem">%</span></span>
                                                                        <span class="px-2">{{ pool.lf }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- 中ts -->
                                                <div class="col-3 col-sm-2 position-relative" :class="{'coruscate':coruscateArr.indexOf('ts')!=-1}" @click="addAmount('ts',$event)">
                                                    <div class="d-flex flex-column justify-content-end justify-content-sm-center align-items-sm-end bg-mermaid w-100 h-100 pe-sm-3">
                                                        <!-- 文本 -->
                                                        <img class="position-absolute h-100 w-2rem end-100 translate-50-x" src="@/assets/images/room/maze/seaweed.png" alt="">
                                                        <img class="position-absolute h-100 w-2rem start-100 translate--50-x" src="@/assets/images/room/maze/seaweed.png" alt="">
                                                        <span class="text-limegreen fw-bold fs-4">通杀</span>
                                                        <span>1 : <span class="fw-bold" :style="{transform: 'scale('+(1+(odds['all']-1)*0.06)+')'}">{{odds["all"]}}</span></span>
                                                        <span class="text-light text-opacity-50">{{limitred['all'].join('-')}}</span>
                                                        <!-- 单额 -->
                                                        <div class="position-absolute start-50 me-5 me-sm-4 top-55 w-0 h-0 transform-3d">
                                                            <div :class="{'chip-pulse opacity-75':submiting.ts>0}" class="position-absolute">
                                                                <div v-for="j,index in chipsConvert(submited.ts+submiting.ts)" :key="j" :style="'bottom:'+(0.2*index)+'rem !important'" class="position-absolute fs-6 text-black translate-middle-x" :class="{'chips-img-shadow':index==0}">
                                                                    <chip :foot-class="['bg-'+j]" :face-class="['bg-'+j]" :chip-text="$root.chipsTxtConvert(j)"></chip>
                                                                    <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                                </div>
                                                            </div>
                                                            <div v-if="submited.ts+submiting.ts>0" :class="[roomInfo.isar==1?'anim-updown-3d':'anim-updown']" class="position-absolute text-black fw-bold fs-6 bottom-0 p-2 rounded-circle bubble" style="transform:translateX(-50%) translateZ(3rem) rotateX(-50deg) translateZ(-2.5rem);">
                                                                <span class="d-block scale pt-100 h-0">
                                                                    <span class="visibility-hidden" :class="{'fs-scale-1_2rem':isScaleAmount.ts}">{{submited.ts+submiting.ts>0?submited.ts+submiting.ts:''}}</span>
                                                                    <small :class="{'text-danger':submited.ts+submiting.ts<limitred.all[0]}" class="text-shadow-white position-absolute top-50 start-50 translate-middle">{{submited.ts+submiting.ts>0?submited.ts+submiting.ts:''}}</small>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <!-- 池额 -->
                                                        <div @click.stop :class="{'rotate-sm-x-_50-z-4px':pool.ts>0&&roomInfo.isar==1}" class="position-absolute bottom-0 start-0 transform-bottom index-1">
                                                            <div @mousemove="isShowPoolText=true" @mouseout="isShowPoolText=false" class="progress-ring fs-_8rem d-flex justify-content-center align-items-center position-relative rounded-pill overflow-hidden" :style="{background: 'conic-gradient(#00e5ff calc('+((pool.ts/(Number(pool.hs)+Number(pool.lf)+Number(pool.hslf)+Number(pool.ls)+Number(pool.hg)+Number(pool.hgls)+Number(pool.ts))*100||0).toFixed()+'%')+'), #787878 0)'}">
                                                                <div :class="{'progress-text-show':isShowPoolText}" class="progress-text text-light h-1_5rem d-flex justify-content-center align-items-center m-_15rem">
                                                                    <span>{{(pool.ts/(Number(pool.hs)+Number(pool.lf)+Number(pool.hslf)+Number(pool.ls)+Number(pool.hg)+Number(pool.hgls)+Number(pool.ts))*100||0).toFixed()}}<span class="fs-_5rem">%</span></span>
                                                                    <span class="px-2">{{ pool.ts }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- 右 -->
                                                <div class="d-flex flex-column flex-sm-row col">
                                                    <!-- ls -->
                                                    <div class="col position-relative" :class="{'coruscate':coruscateArr.indexOf('ls')!=-1}" @click="addAmount('ls',$event)">
                                                        <div class="d-flex flex-column justify-content-evenly justify-content-sm-start align-items-start bg-shak-blue w-100 h-100 ps-4 ps-sm-3">
                                                            <!-- 文本 -->
                                                            <span class="text-primary text-shadow-white fw-bold fs-5">蓝鲨</span>
                                                            <span>1 : <span class="fw-bold" :style="{transform: 'scale('+(1+(odds['select1']-1)*0.06)+')'}">{{odds['select1']}}</span></span>
                                                            <span class="text-light text-opacity-50">{{limitred['select1'].join('-')}}</span>
                                                            <img class="position-absolute top-100 w-100 h-1rem end-0 index-_1 d-sm-none" style="transform: rotateX(180deg) translateY(80%) rotateZ(8deg);" src="@/assets/images/room/maze/seaweed1.png" alt="">
                                                            <!-- 单额 -->
                                                            <div class="position-absolute start-50 me-5 me-sm-4 top-55 w-0 h-0 transform-3d">
                                                                <div :class="{'chip-pulse opacity-75':submiting.ls>0}" class="position-absolute">
                                                                    <div v-for="j,index in chipsConvert(submited.ls+submiting.ls)" :key="j" :style="'bottom:'+(0.2*index)+'rem !important'" class="position-absolute fs-6 text-black translate-middle-x" :class="{'chips-img-shadow':index==0}">
                                                                        <chip :foot-class="['bg-'+j]" :face-class="['bg-'+j]" :chip-text="$root.chipsTxtConvert(j)"></chip>
                                                                        <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                                    </div>
                                                                </div>
                                                                <div v-if="submited.ls+submiting.ls>0" :class="[roomInfo.isar==1?'anim-updown-3d':'anim-updown']" class="position-absolute text-black fw-bold fs-6 bottom-0 p-2 rounded-circle bubble" style="transform:translateX(-50%) translateZ(3rem) rotateX(-50deg) translateZ(-2.5rem);">
                                                                    <span class="d-block scale pt-100 h-0">
                                                                        <span class="visibility-hidden" :class="{'fs-scale-1_2rem':isScaleAmount.ls}">{{submited.ls+submiting.ls>0?submited.ls+submiting.ls:''}}</span>
                                                                        <small :class="{'text-danger':submited.ls+submiting.ls<limitred.select1[0]}" class="text-shadow-white position-absolute top-50 start-50 translate-middle">{{submited.ls+submiting.ls>0?submited.ls+submiting.ls:''}}</small>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- 池额 -->
                                                            <div @click.stop :class="{'rotate-sm-x-_50-z-4px':pool.ls>0&&roomInfo.isar==1}" class="position-absolute bottom-0 end-0 transform-bottom index-1">
                                                                <div @mousemove="isShowPoolText=true" @mouseout="isShowPoolText=false" class="progress-ring fs-_8rem d-flex justify-content-center align-items-center position-relative rounded-pill overflow-hidden" :style="{background: 'conic-gradient(#00e5ff calc('+((pool.ls/(Number(pool.hs)+Number(pool.lf)+Number(pool.hslf)+Number(pool.ls)+Number(pool.hg)+Number(pool.hgls)+Number(pool.ts))*100||0).toFixed()+'%')+'), #787878 0)'}">
                                                                    <div :class="{'progress-text-show':isShowPoolText}" class="progress-text text-light h-1_5rem d-flex justify-content-center align-items-center m-_15rem">
                                                                        <span>{{(pool.ls/(Number(pool.hs)+Number(pool.lf)+Number(pool.hslf)+Number(pool.ls)+Number(pool.hg)+Number(pool.hgls)+Number(pool.ts))*100||0).toFixed()}}<span class="fs-_5rem">%</span></span>
                                                                        <span class="px-2">{{ pool.ls }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- hgls -->
                                                    <div class="col position-relative" :class="{'coruscate':coruscateArr.indexOf('hgls')!=-1}" @click="addAmount('hgls',$event)">
                                                        <div class="d-flex flex-column justify-content-evenly justify-content-sm-start align-items-start bg-shak-blue-turtle w-100 h-100 ps-4 ps-sm-3">
                                                            <!-- 文本 -->
                                                            <div class="d-none d-sm-block">
                                                                <span class="text-danger text-shadow-white fw-bold">红龟</span>
                                                                <span> / </span>
                                                                <span class="text-primary text-shadow-white fw-bold">蓝鲨</span>
                                                            </div>
                                                            <span>1 : <span class="fw-bold" :style="{transform: 'scale('+(1+(odds['select2']-1)*0.06)+')'}">{{odds['select2']}}</span></span>
                                                            <span class="text-light text-opacity-50">{{limitred['select2'].join('-')}}</span>
                                                            <img class="position-absolute top-100 w-100 h-1rem end-0 index-_1 d-sm-none" style="transform: rotateX(180deg) translateY(80%) rotateZ(8deg);" src="@/assets/images/room/maze/seaweed1.png" alt="">
                                                            <img class="position-absolute h-100 w-2rem end-100 translate-50-x d-none d-sm-block" src="@/assets/images/room/maze/seaweed.png" alt="">
                                                            <img class="position-absolute h-100 w-2rem start-100 translate--50-x d-none d-sm-block" src="@/assets/images/room/maze/seaweed.png" alt="">
                                                            <!-- 单额 -->
                                                            <div class="position-absolute start-50 me-5 me-sm-4 top-55 w-0 h-0 transform-3d">
                                                                <div :class="{'chip-pulse opacity-75':submiting.hgls>0}" class="position-absolute">
                                                                    <div v-for="j,index in chipsConvert(submited.hgls+submiting.hgls)" :key="j" :style="'bottom:'+(0.2*index)+'rem !important'" class="position-absolute fs-6 text-black translate-middle-x" :class="{'chips-img-shadow':index==0}">
                                                                        <chip :foot-class="['bg-'+j]" :face-class="['bg-'+j]" :chip-text="$root.chipsTxtConvert(j)"></chip>
                                                                        <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                                    </div>
                                                                </div>
                                                                <div v-if="submited.hgls+submiting.hgls>0" :class="[roomInfo.isar==1?'anim-updown-3d':'anim-updown']" class="position-absolute text-black fw-bold fs-6 bottom-0 p-2 rounded-circle bubble" style="transform:translateX(-50%) translateZ(3rem) rotateX(-50deg) translateZ(-2.5rem);">
                                                                    <span class="d-block scale pt-100 h-0">
                                                                        <span class="visibility-hidden" :class="{'fs-scale-1_2rem':isScaleAmount.hgls}">{{submited.hgls+submiting.hgls>0?submited.hgls+submiting.hgls:''}}</span>
                                                                        <small :class="{'text-danger':submited.hgls+submiting.hgls<limitred.select2[0]}" class="text-shadow-white position-absolute top-50 start-50 translate-middle">{{submited.hgls+submiting.hgls>0?submited.hgls+submiting.hgls:''}}</small>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- 池额 -->
                                                            <div @click.stop :class="{'rotate-sm-x-_50-z-4px':pool.hgls>0&&roomInfo.isar==1}" class="position-absolute bottom-0 end-0 transform-bottom index-1">
                                                                <div @mousemove="isShowPoolText=true" @mouseout="isShowPoolText=false" class="progress-ring fs-_8rem d-flex justify-content-center align-items-center position-relative rounded-pill overflow-hidden" :style="{background: 'conic-gradient(#00e5ff calc('+((pool.hgls/(Number(pool.hs)+Number(pool.lf)+Number(pool.hslf)+Number(pool.ls)+Number(pool.hg)+Number(pool.hgls)+Number(pool.ts))*100||0).toFixed()+'%')+'), #787878 0)'}">
                                                                    <div :class="{'progress-text-show':isShowPoolText}" class="progress-text text-light h-1_5rem d-flex justify-content-center align-items-center m-_15rem">
                                                                        <span>{{(pool.hgls/(Number(pool.hs)+Number(pool.lf)+Number(pool.hslf)+Number(pool.ls)+Number(pool.hg)+Number(pool.hgls)+Number(pool.ts))*100||0).toFixed()}}<span class="fs-_5rem">%</span></span>
                                                                        <span class="px-2">{{ pool.hgls }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- hg -->
                                                    <div class="col position-relative" :class="{'coruscate':coruscateArr.indexOf('hg')!=-1}" @click="addAmount('hg',$event)">
                                                        <div class="d-flex flex-column justify-content-evenly justify-content-sm-start align-items-start bg-turtle w-100 h-100 ps-4 ps-sm-3">
                                                            <!-- 文本 -->
                                                            <span class="text-danger text-shadow-white fw-bold fs-5">红龟</span>
                                                            <span>1 : <span class="fw-bold" :style="{transform: 'scale('+(1+(odds['select1']-1)*0.06)+')'}">{{odds['select1']}}</span></span>
                                                            <span class="text-light text-opacity-50">{{limitred['select1'].join('-')}}</span>
                                                            <!-- 单额 -->
                                                            <div class="position-absolute start-50 me-5 me-sm-4 top-55 w-0 h-0 transform-3d">
                                                                <div :class="{'chip-pulse opacity-75':submiting.hg>0}" class="position-absolute">
                                                                    <div v-for="j,index in chipsConvert(submited.hg+submiting.hg)" :key="j" :style="'bottom:'+(0.2*index)+'rem !important'" class="position-absolute fs-6 text-black translate-middle-x" :class="{'chips-img-shadow':index==0}">
                                                                        <chip :foot-class="['bg-'+j]" :face-class="['bg-'+j]" :chip-text="$root.chipsTxtConvert(j)"></chip>
                                                                        <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                                    </div>
                                                                </div>
                                                                <div v-if="submited.hg+submiting.hg>0" :class="[roomInfo.isar==1?'anim-updown-3d':'anim-updown']" class="position-absolute text-black fw-bold fs-6 bottom-0 p-2 rounded-circle bubble" style="transform:translateX(-50%) translateZ(3rem) rotateX(-50deg) translateZ(-2.5rem);">
                                                                    <span class="d-block scale pt-100 h-0">
                                                                        <span class="visibility-hidden" :class="{'fs-scale-1_2rem':isScaleAmount.hg}">{{submited.hg+submiting.hg>0?submited.hg+submiting.hg:''}}</span>
                                                                        <small :class="{'text-danger':submited.hg+submiting.hg<limitred.select1[0]}" class="text-shadow-white position-absolute top-50 start-50 translate-middle">{{submited.hg+submiting.hg>0?submited.hg+submiting.hg:''}}</small>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- 池额 -->
                                                            <div @click.stop :class="{'rotate-sm-x-_50-z-4px':pool.hg>0&&roomInfo.isar==1}" class="position-absolute bottom-0 end-0 transform-bottom index-1">
                                                                <div @mousemove="isShowPoolText=true" @mouseout="isShowPoolText=false" class="progress-ring fs-_8rem d-flex justify-content-center align-items-center position-relative rounded-pill overflow-hidden" :style="{background: 'conic-gradient(#00e5ff calc('+((pool.hg/(Number(pool.hs)+Number(pool.lf)+Number(pool.hslf)+Number(pool.ls)+Number(pool.hg)+Number(pool.hgls)+Number(pool.ts))*100||0).toFixed()+'%')+'), #787878 0)'}">
                                                                    <div :class="{'progress-text-show':isShowPoolText}" class="progress-text text-light h-1_5rem d-flex justify-content-center align-items-center m-_15rem">
                                                                        <span>{{(pool.hg/(Number(pool.hs)+Number(pool.lf)+Number(pool.hslf)+Number(pool.ls)+Number(pool.hg)+Number(pool.hgls)+Number(pool.ts))*100||0).toFixed()}}<span class="fs-_5rem">%</span></span>
                                                                        <span class="px-2">{{ pool.hg }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 按钮区 -->
                                    <div class="d-flex justify-content-between text-nowrap order-3 mb-1 mb-sm-0 px-1 position-relative justify-content-sm-around px-sm-0 ms-sm-2 flex-sm-column">
                                        <button class="btn bg-gradient text-light opacity-100 mb-sm-2" :class="{'disabled btn-secondary':!canClear,'btn-shadow-right-secondary':roomInfo.isar==1&&!canClear,'btn-shadow-right-secondary-mini':(roomInfo.isar!=1&&!canClear),'btn-warning':canClear,'btn-shadow-right-warning':roomInfo.isar==1&&canClear,'btn-shadow-right-warning-mini':roomInfo.isar!=1&&canClear,'mb-sm-1':roomInfo.isar==1,'mb-sm-2':roomInfo.isar!=1}" :disabled="!canClear" @click="submitEvent('clear')">{{$t("room.clear")}}</button>
                                        <button class="btn bg-gradient text-light opacity-100 mb-sm-2" :class="{'disabled btn-secondary':!canCancel,'btn-shadow-right-secondary':roomInfo.isar==1&&!canCancel,'btn-shadow-right-secondary-mini':(roomInfo.isar!=1&&!canCancel),'btn-danger':canCancel,'btn-shadow-right-danger':roomInfo.isar==1&&canCancel,'btn-shadow-right-danger-mini':roomInfo.isar!=1&&canCancel,'mb-sm-1':roomInfo.isar==1,'mb-sm-2':roomInfo.isar!=1}" :disabled="!canCancel" @click="submitEvent('cancel')">{{$t("room.cancel")}}</button>
                                        <button class="btn bg-gradient text-light opacity-100 mb-sm-2" :class="{'disabled btn-secondary':!canConfirm,'btn-shadow-right-secondary':roomInfo.isar==1&&!canConfirm,'btn-shadow-right-secondary-mini':(roomInfo.isar!=1&&!canConfirm),'btn-success':canConfirm,'btn-shadow-right-success':roomInfo.isar==1&&canConfirm,'btn-shadow-right-success-mini':roomInfo.isar!=1&&canConfirm}" :disabled="!canConfirm" @click="submitEvent('confirm')">{{$t("room.confirm")}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 路单区 -->
            <div class="flex-grow-1 d-flex flex-column flex-sm-row h-0 position-relative" :class="[(gameModel==GAME_MODEL.normal)?'flex-sm-grow-0 h-sm-7rem':'overflow-hidden']">
                <!-- 路单信息区 -->
                <div class="d-flex flex-wrap flex-sm-nowrap flex-sm-column w-xs-100 w-5rem">
                    <!-- 统计 -->
                    <div class="d-flex flex-sm-column text-light fs-_6rem small-xs w-xs-100">
                        <div class="col d-flex justify-content-between align-items-center overflow-hidden">
                            <div class="bg-gradient w-3rem w-sm-2_4rem text-center skew-x--45 ms--_5rem index-1" :style="{background:COLOR.red}" style="box-shadow: 0 0 .2rem #000;">
                                <span class="skew-x-45 d-block">红鲨</span>
                            </div>
                            <div class="flex-grow-1 skew-x--45 text-center overflow-hidden bg-gradient me--_5rem position-relative">
                                <div class="bg-warning bg-gradient h-100 position-absolute top-0 start-0 skew-x-45 ms--_5rem" :style="{width:getPearlCountPercent(pearlCount.hs)}"></div>
                                <span class="skew-x-45 d-block ms--_5rem">{{pearlCount.hs}}</span>
                            </div>
                        </div>
                        <div class="col d-flex justify-content-between align-items-center overflow-hidden">
                            <div class="bg-gradient w-3rem w-sm-2_4rem text-center skew-x--45 ms--_5rem index-1" :style="{background:COLOR.redDark}" style="box-shadow: 0 0 .2rem #000;">
                                <span class="skew-x-45 d-block">红龟</span>
                            </div>
                            <div class="flex-grow-1 skew-x--45 text-center overflow-hidden bg-gradient me--_5rem position-relative">
                                <div class="bg-warning bg-gradient h-100 position-absolute top-0 start-0 skew-x-45 ms--_5rem" :style="{width:getPearlCountPercent(pearlCount.hg)}"></div>
                                <span class="skew-x-45 d-block ms--_5rem">{{pearlCount.hg}}</span>
                            </div>
                        </div>
                        <div class="col d-flex justify-content-between align-items-center overflow-hidden">
                            <div class="bg-gradient w-3rem w-sm-2_4rem text-center skew-x--45 ms--_5rem index-1" :style="{background:COLOR.green}" style="box-shadow: 0 0 .2rem #000;">
                                <span class="skew-x-45 d-block">通杀</span>
                            </div>
                            <div class="flex-grow-1 skew-x--45 text-center overflow-hidden bg-gradient me--_5rem position-relative">
                                <div class="bg-warning bg-gradient h-100 position-absolute top-0 start-0 skew-x-45 ms--_5rem" :style="{width:getPearlCountPercent(pearlCount.ts)}"></div>
                                <span class="skew-x-45 d-block ms--_5rem">{{pearlCount.ts}}</span>
                            </div>
                        </div>
                        <div class="col d-flex justify-content-between align-items-center overflow-hidden">
                            <div class="bg-gradient w-3rem w-sm-2_4rem text-center skew-x--45 ms--_5rem index-1" :style="{background:COLOR.blue}" style="box-shadow: 0 0 .2rem #000;">
                                <span class="skew-x-45 d-block">蓝鲨</span>
                            </div>
                            <div class="flex-grow-1 skew-x--45 text-center overflow-hidden bg-gradient me--_5rem position-relative">
                                <div class="bg-warning bg-gradient h-100 position-absolute top-0 start-0 skew-x-45 ms--_5rem" :style="{width:getPearlCountPercent(pearlCount.ls)}"></div>
                                <span class="skew-x-45 d-block ms--_5rem">{{pearlCount.ls}}</span>
                            </div>
                        </div>
                        <div class="col d-flex justify-content-between align-items-center overflow-hidden">
                            <div class="bg-gradient w-3rem w-sm-2_4rem text-center skew-x--45 ms--_5rem index-1" :style="{background:COLOR.blueDark}" style="box-shadow: 0 0 .2rem #000;">
                                <span class="skew-x-45 d-block">蓝蝠</span>
                            </div>
                            <div class="flex-grow-1 skew-x--45 text-center overflow-hidden bg-gradient me--_5rem position-relative">
                                <div class="bg-warning bg-gradient bg-gradient h-100 position-absolute top-0 start-0 skew-x-45 ms--_5rem" :style="{width:getPearlCountPercent(pearlCount.lf)}"></div>
                                <span class="skew-x-45 d-block ms--_5rem">{{pearlCount.lf}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-grow-1">
                    <!-- 路单 -->
                    <div id="showLog" class="flex-grow-1 d-flex bg-light">
                        <div v-for="i in showLogColumn" :key="i" class="d-flex flex-column col border-end">
                            <div v-for="j in 6" :key="j" class="col border-bottom d-flex justify-content-center align-items-center position-relative">
                                <img v-if="pearlArr.length>0&&pearlArr.slice(-showLogColumn*6+1)[(i-1)*6+j-1]" class="mw-100 mh-100 position-absolute top-50 start-50 translate-middle" :src="require('@/assets/images/room/maze/'+getLogImg((i-1)*6+j-1)+'.png')" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 换台区 -->
            <change-room :class="{'me-sm-0':roomInfo.isar==1}" :room-list="roomList" :count-list="countList" :pearl-obj="pearlObj"></change-room>
        </div>
    </div>
</template>
<script>
import {GAME_MODEL,COLOR,GAME_ID,COMMAND,AMOUTN_ARR,LAYER_TYPE,SUBMIT_RESULT,MUTATION_TYPE,CANCEL_RESULT} from "@/assets/js/config.js"
import { getDeviceType } from '@/assets/js/common.js'
import { useLayer } from '@/assets/js/useLayer';
import mediaVideo from "@/components/public/video.vue";
import roomList from '@/components/public/roomList.vue';
import navbarVertical from '@/components/public/navbarVertical.vue';
import navbar from '@/components/public/navbar.vue';
import notice from '@/components/public/notice.vue';
import changeRoom from '@/components/public/changeRoom.vue'
import changeAmount from '@/components/public/changeAmount.vue'
import chip from '@/components/public/chip.vue'
export default {
    components: { 
        mediaVideo,
        roomList,
        changeRoom,
        navbarVertical,
        navbar,
        notice,
        changeAmount,
        chip
    },
    props:{
        hasChatMsg:false,//是否有未读的客服消息
        isFullscreen:{
            type:Boolean,
            default:false
        },//当前是否全屏
    },
    data(){
        return{
            GAME_ID,
            COLOR,
            GAME_MODEL,
            videoList:[],//视频线路地址，当前支持最多两个
            amount:10,//选中额度
            isShowMoreAmount:false,//是否显示更多筹码
            canClear:false,//是否可以点击清除
            canCancel:false,//是否可以点击取消
            canConfirm:false,//是否可以点击确定
            showLogColumn:0,//显示路单列数
            lastVideoLine:"",//上一次获取视频的视频线路id
            odds:{select1:0,select2:0,all:0},
            limitred:{select1:[0,0],select2:[0,0],all:[0,0]},
            pearlObj: {
                id:0,//台面id
                pearl:[]//路单数据
            },//要重绘路单的对象
            pearlArr:[],//台面路单列表
            countList:[],//路单统计列表
            pearlCount:{hs:0,hg:0,ts:0,ls:0,lf:0},//统计
            submited:{hs:0,lf:0,hslf:0,ls:0,hg:0,hgls:0,ts:0},//当前模式已提交的额度列表
            submiting:{hs:0,lf:0,hslf:0,ls:0,hg:0,hgls:0,ts:0},//当前模式将要提交的额度列表
            pool:{hs:0,lf:0,hslf:0,ls:0,hg:0,hgls:0,ts:0},//池
            isScaleAmount:{hs:false,lf:false,hslf:false,ls:false,hg:false,hgls:false,ts:false},//是否放大码额
            isShowPoolText:false,//是否显示池具体值
            coruscateArr:[],//闪烁位集合，存放将要闪烁的位置
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        roomInfo() {
            return this.$store.state.roomInfo;
        },
        currAmountList(){
            return this.$store.state.currAmountList;
        },
        gameModel(){
            return this.$store.state.gameModel;
        },
        currVideoLine(){
			return this.$store.state.currVideoLine;
		},
        roomList(){
            return this.$store.state.roomList;
        },
    },
    mounted(){
        this.setShowLogColumn();
        this.init();
        this.setWsMessage();
        addEventListener("resize",this.setShowLogColumn);
    },
    unmounted() {
        removeEventListener("resize",this.setShowLogColumn);
        delete this.$root.wsMsgObj["maze"];
    },
    methods:{
        init(){
            //获取台面视频
            if(this.currVideoLine==""){
                useLayer({str:this.$t("video.noVideoLine")});
            }else{
                this.$root.wsSendJson({
                    command:COMMAND.all_getvideo,
                    tableId:this.roomInfo.id,
                    lineId:this.currVideoLine,
                    userid:this.userInfo.id,
                    guid:this.userInfo.guid
                });
                this.lastVideoLine=this.currVideoLine;
            }
            this.$root.wsSendJson({
                command:COMMAND.all_getodds,
                game:this.roomInfo.game,
                tableId:this.roomInfo.id,
                userid:this.userInfo.id,
                guid:this.userInfo.guid
            });
            //获取限红
            this.$root.wsSendJson({
                command:COMMAND.all_getlimitredinfo,
                game:this.roomInfo.game,
                userid:this.userInfo.id,
                guid:this.userInfo.guid
            });
            //获取台面路单
            this.$root.getRoomPearl(GAME_ID.maze,this.roomInfo.id);
            //获取各位置已提交额度
            this.$root.wsSendJson({
                command:COMMAND.all_getbetdetail,
                game:this.roomInfo.game,
                tableId:this.roomInfo.id,
                boot:this.roomInfo.boot,
                innings:this.roomInfo.innings,
                userid:this.userInfo.id,
                guid:this.userInfo.guid
            });
            //获取池额
            this.$root.wsSendJson({
                command:COMMAND.all_getpool,
                game:this.roomInfo.game,
                tableId:this.roomInfo.id,
                userid:this.userInfo.id,
                guid:this.userInfo.guid
            });
        },
        setWsMessage(){
            this.$root.wsMsgObj["maze"]=(data)=>{
                switch (data.command) {
                    case COMMAND.all_getroompearl:
                        if(data.id==this.roomInfo.id){//获取的是当前台面的数据
                            this.pearlArr=data.pearl;
                            this.pearlCount.hs=data.count[0];
                            this.pearlCount.ls=data.count[1];
                            this.pearlCount.lf=data.count[2];
                            this.pearlCount.hg=data.count[3];
                            this.pearlCount.ts=data.count[4];
                        }
                        if(this.roomList&&this.roomList.find(v=>v.id==data.id)){//用于切换台面功能获取数据，换台列表中有才需要更新
                            this.pearlObj={
                                id:data.id,
                                pearl:data.pearl
                            }
                            this.countList[data.id]=data.count;
                        }
                        break;
                    case COMMAND.all_getvideo:
                        let videoArr=data.video;
                        let list=[];//拼装好的视频地址数组
                        for (let i = 0; i < videoArr.length; i++) {
                            list.push(data.flvline+'/'+videoArr[i]+'.flv');
                        }
                        this.videoList=list;
                        break;
                    case COMMAND.all_getodds:
                        data.game==this.roomInfo.game&&data.tableId==this.roomInfo.id&&(this.odds=data.odds);
                        break;
                    case COMMAND.all_getlimitredinfo:
                        this.limitred=data.limitred;
                        break;
                    case COMMAND.maze_submitbet:
                        switch (data.result) {
                            case SUBMIT_RESULT.success:
                                useLayer({str:this.$t("common.subSuccess")});
                                this.$store.commit({
                                    type:MUTATION_TYPE.setUserInfo,
                                    userInfo:{
                                        realCoin:data.realmoney
                                    }
                                });
                                for (let i in this.submited) {//将本次提交的额度追加到已提交的额度中
                                    this.submited[i]+=this.submiting[i];
                                }
                                //设置提交列表
                                this.$store.commit({
                                    type:MUTATION_TYPE.setCurrBetList,
                                    room:{
                                        game:this.roomInfo.game,
                                        id:this.roomInfo.id,
                                        detail:JSON.parse(JSON.stringify(this.submited)),
                                        winArr:[]
                                    }
                                });
                                this.resetAmount("submiting");//清空将提交额度列表
                                break;
                            case SUBMIT_RESULT.ban:
                                useLayer({str:this.$t("common.subBan")});
                                break;
                            case SUBMIT_RESULT.unmoney:
                                useLayer({str:this.$t("common.unMoney")});
                                break;
                            case SUBMIT_RESULT.countdown:
                                useLayer({str:this.$t("common.subCountdown")});
                                break;
                            case SUBMIT_RESULT.outside:
                                useLayer({str:this.$t("common.unLimit")});
                                break;
                            case SUBMIT_RESULT.service:
                                useLayer({str:this.$t("common.service")});
                                break;
                            case SUBMIT_RESULT.malice:
                                useLayer({str:""});
                                break;
                            default:
                                useLayer({str:this.$t("common.subErr")});
                                break;
                        }
                        break;
                    case COMMAND.all_endgame:
                        data.id==this.roomInfo.id&&this.resetAmount("submiting");
                        break;
                    case COMMAND.all_getgain:
                        if(data.id==this.roomInfo.id){
                            setTimeout(() => {
                                this.resetAmount("all",2);
                            }, 5000);
                            if(data.win!=0||data.lose!=0){
                                useLayer({str:(data.win > Math.abs(data.lose)? this.$t("common.win"):this.$t("common.lose"))+Math.abs(data.win - data.lose)});
                            }
                        }
                        break;
                    case COMMAND.all_cancelbet:
                        if(data.result==CANCEL_RESULT.success){
                            this.resetAmount("all",2);
                            this.$store.commit({
                                type:MUTATION_TYPE.setUserInfo,
                                userInfo:{
                                    realCoin:data.realmoney
                                }
                            })
                            useLayer({str:this.$t("common.cancelSuccess")});
                        }else{
                            useLayer({str:this.$t("common.cancelErr")});
                        }
                        break;
                    case COMMAND.all_changeboot:
                        if(data.id==this.roomInfo.id){
                            this.pearlArr=[];
                            this.pokerArr=[];
                            this.$store.commit({
                                type:MUTATION_TYPE.setRoomInfo,
                                roomInfo:{
                                    boot:data.boot,
                                    innings:data.innings
                                }
                            })
                        }
                        this.pearlObj={
                            id:data.id,
                            pearl:[]
                        }
                        this.countList[data.id]=[0,0,0];
                        break;
                    case COMMAND.all_entertable:
                        this.$root.$refs.startAudioPlayer.pause();
                        this.$root.$refs.endAudioPlayer.pause();
                        this.$root.$refs.tenAudioPlayer.pause();
                        // this.$refs.resultAudioPlayer.pause();
                        this.pool={hs:0,lf:0,hslf:0,ls:0,hg:0,hgls:0,ts:0};
                        this.init();
                        this.resetAmount("submiting");
                        break;
                    case COMMAND.all_getbetdetail:
                        if(data.id==this.roomInfo.id){    
                            this.submited={
                                hs:Number(data.detail.hs||0),
                                lf:Number(data.detail.lf||0),
                                hslf:Number(data.detail.hslf||0),
                                ls:Number(data.detail.ls||0),
                                hg:Number(data.detail.hg||0),
                                hgls:Number(data.detail.hgls||0),
                                ts:Number(data.detail.ts||0)
                            };
                        }
                        break;
                    case COMMAND.all_getpool:
                        data.id==this.roomInfo.id&&(this.pool=data.pool);
                        break;
                    case COMMAND.all_gameresult:
                        if(data.id==this.roomInfo.id){
                            this.pearlArr.push(data.pearl);
                            this.setCoruscate(data.pearl);
                        }
                        break;
                }
            }
        },
        /**
         * 设置记录显示列数
         */
        setShowLogColumn(){
            let style=getComputedStyle(document.getElementById("showLog").parentElement);
			let width=style.width.replace('px','');
			let height=style.height.replace('px','');
            let cellHeight=height/6;//单元格高度
            let column=Math.trunc(width / cellHeight);//截断取整
            this.showLogColumn=column;
        },
        /**
         * 将路单统计的值折成百分比
         * @param number 要计算成百分比的值
         */
        getPearlCountPercent(number){
            let total=this.pearlCount.hs+this.pearlCount.hg+this.pearlCount.ts+this.pearlCount.ls+this.pearlCount.lf;
            if(total>0){
                return ((number/total)*100).toFixed(2)+"%";
            }else{
                return "0%";
            }
        },
        /**
         * 获取额度
         * @param {String} type 额度类型(submited、submiting、all)
         */
        getAmountCount(type){
            let count=0;
            if(type=="submiting"||type=="all"){//预投或总投
                for (let i in this.submiting) {
                    count+=this.submiting[i];
                }
            }
            if(type=="submited"||type=="all"){//已投或总投
                for (let i in this.submited) {
                    count+=this.submited[i];
                }
            }
            return count;
        },
        /**
         * 为位置追加将要提交的额度
         * @param {String} type 位置类型(z、x、h、zd、xd)
         */
        addAmount(type,event){
            let otherType="";
            if(type.length==4){//组合位置
                otherType="select2";
            }else if(type=="ts"){
                otherType="all";
            }else{
                otherType="select1";
            }
            let limitred=this.limitred[otherType];//获取限红
            let amount=this.amount;
            if(!this.odds[otherType]){
                useLayer({str:this.$t("room.odds0")});
                return;
            }
            if(this.roomInfo.countdown<=0){
                useLayer({str:this.$t("room.noStartGame")});
                return;
            }else if(amount!=Infinity&&this.userInfo.realCoin<this.getAmountCount("submiting")+amount){//余额不足
                useLayer({str:this.$t("common.unMoney")});
                return;
            }
            if(amount!=Infinity){//非满额度
                if(amount>limitred[1]){//单次高于上限
                    useLayer({str:this.$t("room.higherLimitred")+limitred[1]});
                    return;
                }else if(this.submiting[type]+this.submited[type]+amount>limitred[1]){//多次并高于上限
                    useLayer({str:this.$t("room.laveLimitred")+(limitred[1]-this.submiting[type]-this.submited[type])});
                    return;
                }
            }else{//满额度
                amount=limitred[1]-this.submiting[type]-this.submited[type];//计算位置还能加多少额度
                if(amount<=0){
                    useLayer({str:this.$t("room.fullAmount")});
                    return;
                }
                if(this.userInfo.realCoin<amount){//余额不够加满
                    amount=this.userInfo.realCoin;//则有多少余额就加多少
                }
            }
            this.submiting[type]=this.submiting[type]+amount;
            if(event){
                this.isScaleAmount[type]=true;
                setTimeout(() => {
                    this.isScaleAmount[type]=false;
                }, 120);
            }
        },
        /**
         * 获取路单图片名称
         */
        getLogImg(idx){
            let imgName="";
            let pearl = this.pearlArr.slice(-this.showLogColumn*6+1)[idx];
            switch (pearl) {
                case "hs":
                    imgName="hs";
                    break;
                case "hg":
                    imgName="hg";
                    break;
                case "ts":
                    imgName="ts";
                    break;
                case "ls":
                    imgName="ls";
                    break;
                case "lf":
                    imgName="lf";
                    break;
            }
            return imgName;
        },
        /**
         * 额度换算
         */
        chipsConvert(amount){
            let arr=[];//最终转换成的额度
            let amountArr = AMOUTN_ARR.slice(0,AMOUTN_ARR.length-1);//取除了梭哈之外的额度
            for (let i = amountArr.length-1; i >= 0; i--) {
                if(amount>=amountArr[i]){
                    let num=Math.floor(amount/amountArr[i]);//获取要换算的额度最多能换到多少个当前遍历到的额度
                    for (let j = 0; j < num; j++) {
                        arr.push(amountArr[i]);
                    }
                    amount-=num*amountArr[i];
                }
            }
            return arr;
        },
        /**
         * 重置额度
         * @param {String} type 额度类型(submited、submiting、all)
         * @param {Number} rebate 免佣类型(0:非免佣 1:免佣 2:免佣+非免佣)
         */
        resetAmount(type){
            if(type=="submiting"||type=="all"){//预投或总投
                for (let i in this.submiting) {
                    this.submiting[i]=0;
                }
            }
            if(type=="submited"||type=="all"){//已投或总投
                for (let i in this.submited) {
                    this.submited[i]=0;
                }
            }
        },
        /**
         * 提交事件
         */
        submitEvent(event){
            switch (event) {
                case "clear"://点击清除
                    this.getAmountCount("submiting")!=0&&this.resetAmount("submiting");
                    break;
                case "cancel"://点击取消
                    if(this.canCancel){
                        useLayer({
                            type:LAYER_TYPE.confirm,
                            str:this.$t("common.isCancel"),
                            btn:[this.$t("common.yes"),this.$t("common.no")],
                            yesFn:(i)=>{
                                layer.close(i);
                                this.$root.wsSendJson({
                                    command:COMMAND.all_cancelbet,
                                    game:this.roomInfo.game,
                                    tableId:this.roomInfo.id,
                                    boot:this.roomInfo.boot,
                                    innings:this.roomInfo.innings,
                                    userid:this.userInfo.id,
                                    guid:this.userInfo.guid
                                })
                            }
                        })
                    }
                    break;
                case "confirm"://点击确定
                    if(this.canConfirm){
                        let order=[];
                        this.submiting.hs>0&&order.push({"code":"hs","money":this.submiting.hs});
                        this.submiting.lf>0&&order.push({"code":"lf","money":this.submiting.lf});
                        this.submiting.hslf>0&&order.push({"code":"hslf","money":this.submiting.hslf});
                        this.submiting.ls>0&&order.push({"code":"ls","money":this.submiting.ls});
                        this.submiting.hg>0&&order.push({"code":"hg","money":this.submiting.hg});
                        this.submiting.hgls>0&&order.push({"code":"hgls","money":this.submiting.hgls});
                        this.submiting.ts>0&&order.push({"code":"ts","money":this.submiting.ts});
                        if(order.length>0){
                            this.$root.wsSendJson({
                                command:COMMAND.maze_submitbet,
                                game:this.roomInfo.game,
                                tableId:this.roomInfo.id,
                                boot:this.roomInfo.boot,
                                innings:this.roomInfo.innings,
                                currAmount:this.getAmountCount("submiting"),
                                totalAmount:this.getAmountCount("submiting")+this.getAmountCount("submited")+this.getAmountCount("submited"),
                                order,
                                userid:this.userInfo.id,
                                ip:this.$root.ip.cip,
                                loginType:getDeviceType(),
                                guid:this.userInfo.guid
                            });
                        }
                    }
                    break;
            }
        },
        /**
         * 设置闪烁位
         */
        setCoruscate(pearl,fn){
            let arr=[];
            pearl.indexOf("hs") != -1 && arr.push('hs',"hslf");
            pearl.indexOf("lf") != -1 && arr.push('lf',"hslf");
            pearl.indexOf("ls") != -1 && arr.push('ls',"hgls");
            pearl.indexOf("hg") != -1 && arr.push('hg',"hgls");
            pearl.indexOf("ts") != -1 && arr.push('ts');
            this.coruscateArr=arr;
            setTimeout(() => {
                this.coruscateArr=[];
                fn&&fn();
            }, 5000);
        },
    },
    watch:{
        /**
         * 监听视频线路id改变
         */
        currVideoLine(newVal,oldVal){
            if(newVal!=""){
                if(newVal&&this.lastVideoLine!=newVal){
                    //获取台面视频
                    this.$root.wsSendJson({
                        command:COMMAND.all_getvideo,
                        tableId:this.roomInfo.id,
                        lineId:newVal,
                        userid:this.userInfo.id,
                        guid:this.userInfo.guid
                    })
                    this.lastVideoLine=newVal;
                }
            }else{
                this.videoList=null;
            }
        },
        /**
         * 监听将要提交的额度变化
         */
        submiting:{
            handler(){
                if(this.getAmountCount("submiting")<=0||this.roomInfo.countdown<=0){
                    this.canClear=false;
                    this.canConfirm=false;
                }else{
                    this.canClear=true;
                    this.canConfirm=true;
                }
            },
            deep:true
        },
        /**
         * 监听已提交过的额度变化
         */
        submited:{
            handler(){
                if(this.getAmountCount("submited")<=0||this.roomInfo.countdown<=0){
                    this.canCancel=false;
                }else{
                    this.canCancel=true;
                }
            },
            deep:true
        },
        /**
         * 监听guid改变（断线重连）
         */
        "userInfo.guid"(newVal,oldVal){
            if(newVal!=oldVal&&newVal!=""){
                this.init();
            }
        },
        "roomInfo.countdown"(newVal){
            if(newVal==0){
                this.canCancel=false;
                this.canConfirm=false;
            }
        },
    }
}
</script>